// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  padding: 20px 30px;
}

div .mat-mdc-dialog-container {
  padding: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/main/properties/index/show-reason-dialog/show-reason-dialog.component.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;AADJ;;AAIA;EACI,uBAAA;AADJ","sourcesContent":["@import 'src/@fuse/scss/fuse';\n\n.content {\n    padding: 20px 30px;\n}\n\ndiv .mat-mdc-dialog-container {\n    padding: 0px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
